import type { MenuItemListTypes } from '@Shelly/shelly-design-system';
import type { ChartConfig, ChartVariantsType } from 'src/types/Chart';

export type ChartTimeType = { from: Date; to: Date };

export type ChartMoreActionType = Omit<Partial<MenuItemListTypes>, 'title'> & {
	title: {
		value: string;
		translation: string;
	};
	id: string;
};

export type ChartMoreActionsGroupType = {
	groupTitle: {
		translation?: string;
		value?: string;
	};
	isGroupTitle?: boolean;
	items: ChartMoreActionType[];
};

export const CHART_VARIANTS_LIST: ChartVariantsType[] = ['line', 'bar', 'area', 'area', 'sparkline'];

export const MAPPED_CHART_TYPE_INDEXES = {
	line: 0,
	bar: 1,
	areaspline: 3,
	area: 3,
	sparkline: 4,
};

export const chartMoreActionsGroupedItems: ChartMoreActionsGroupType[] = [
	{
		groupTitle: {
			value: 'General',
			translation: 'chart_more_options_general_label',
		},
		isGroupTitle: true,
		items: [
			{
				id: 'sparkline',
				title: {
					value: 'Sparkline',
					translation: 'chart_more_options_chart_type_sparkline_label',
				},
				icon: 'fas fa-wave-sine',
				isSelectable: true,
			},
			{
				id: 'fullScreen',
				title: {
					value: 'Full screen',
					translation: 'chart_more_options_full_screen_label',
				},
				icon: 'fas fa-up-right-and-down-left-from-center',
				isSelectable: false,
			},
			{
				id: 'exportFile',
				title: {
					value: 'Export .csv',
					translation: 'chart_more_options_export_label',
				},
				icon: 'fas fa-file-arrow-down',
				isSelectable: false,
			},
			{
				id: 'netMetering',
				title: {
					value: 'Net Metering',
					translation: 'net_metering_tab',
				},
				icon: 'fas fa-solar-panel',
				isSelectable: false,
			},
		],
	},
	{
		groupTitle: {
			value: 'Chart type',
			translation: 'chart_more_options_chart_type_label',
		},
		isGroupTitle: true,
		items: [
			{
				id: 'bar',
				title: {
					value: 'Bar chart',
					translation: 'chart_more_options_chart_type_bar_label',
				},
				icon: 'fas fa-chart-column',
				isSelectable: true,
			},
			{
				id: 'area',
				title: {
					value: 'Area chart',
					translation: 'chart_more_options_chart_type_sharp_label',
				},
				icon: 'fa-sharp fas fa-chart-area',
				isSelectable: true,
			},
			{
				id: 'line',
				title: {
					value: 'Line chart',
					translation: 'chart_more_options_chart_type_line_label',
				},
				icon: 'fas fa-chart-line',
				isSelectable: true,
			},
		],
	},
];

export const getDefaultMatrix = (len: number) => {
	return Array.from(Array(len), () => new Array());
};

export const setSelectedItemID = (chartConfig: ChartConfig) => {
	let foundAction: ChartMoreActionType | undefined;
	const normalizedType = chartConfig.type === 'areaspline' ? 'area' : chartConfig.type;
	chartMoreActionsGroupedItems.forEach((gItem) => {
		foundAction ??= gItem.items.find((item) => item.id === normalizedType);
	});
	return foundAction?.id ?? 'line';
};
